import { all, fork } from "redux-saga/effects";
import authSaga from "./authSaga";
import accountSaga from "./accountSaga";
import settingSaga from "./settingSaga";
import toastActionWatcher from "./toastSaga";
import orderSettingSaga from "./orderSettingSaga";
import menuSaga from "./menuSaga";
import financeSaga from "./financeSaga";
import orderInvoicesSaga from "./orderInvoicesSaga";
function* rootSaga() {
  yield all([
    fork(authSaga),
    fork(toastActionWatcher),
    fork(accountSaga),
    fork(settingSaga),
    fork(orderSettingSaga),
    fork(menuSaga),
    fork(financeSaga),
    fork(orderInvoicesSaga),
  ]);
}

export default rootSaga;
